import { filterSlice } from './filterSlice';
import { selectedTransactionsSlice } from './selectedTransactionsSlice';
import { userSlice } from './userSlice';

export const slices = {
  [userSlice.name]: userSlice.reducer,
  [filterSlice.name]: filterSlice.reducer,
  [selectedTransactionsSlice.name]: selectedTransactionsSlice.reducer,
};
